import "./sms-disclaimer.css";

import { INewName } from "../../../interfaces/global.interfaces";
import { Context } from "../../../models/context";
import { Data } from "../../../models/data";
import { LocalizationService } from "../../../services/localization-service";
import { Util } from "../../../utils/util";
import { PrivacyTerms } from "../PrivacyTerms/privacy-and-terms";

export class SmsDisclaimer {

    public static render(elementId: string, data: Data, context: Context, localizationService: LocalizationService): void {
        const element = document.getElementById(elementId);
        if (!element)
            return;

        const brandName = context.getProperty("brandInfo")?.Name ?? "";
        const nameObj: INewName[] = localizationService.getSupportedLanguages().map(lang => ({
            lc: lang,
            text: SmsDisclaimer.getText(data, brandName, localizationService, lang)
        }));

        element.setAttribute("ltagj", Util.toLtagj(nameObj));
        element.innerHTML = SmsDisclaimer.getText(data, brandName, localizationService);
        element.onclick = SmsDisclaimer._onPolicyLinkClick;
    }

    public static getText(data: Data, brandName: string, localizationService: LocalizationService, languageCode?: string): string {
        const disclaimer = localizationService.names("SmsDisclaimer", languageCode, brandName);
        const policyLinks = SmsDisclaimer._getPolicyLinksText(data, localizationService, languageCode);
        return policyLinks ? `${disclaimer} ${policyLinks}` : disclaimer;
    }

    private static _getPolicyLinksText(data: Data, localizationService: LocalizationService, languageCode?: string): string {
        const settings = data.getBrandProperty("Settings")?.OOS;
        const privacyTerms = new PrivacyTerms();
        const terms = settings?.termsOfUseUrl?.trim() ? privacyTerms.getTermsOfUseUrl(data, localizationService, languageCode, "SmsDisclaimerTerms") : "";
        const privacy = settings?.privacyPolicyUrl?.trim() ? privacyTerms.getPrivacyPolicyUrl(data, localizationService, languageCode) : "";

        if (terms && privacy)
            return localizationService.names("SmsDisclaimerViewTermsAndPrivacy", languageCode, terms, privacy);
        if (terms)
            return localizationService.names("SmsDisclaimerViewTerms", languageCode, terms);
        if (privacy)
            return localizationService.names("SmsDisclaimerViewPrivacy", languageCode, privacy);

        return "";
    }

    // In the wrapped app a target="_blank" anchor would navigate the jsBridge WebView, so route through the native bridge like Checkout does.
    private static readonly _onPolicyLinkClick = (event: MouseEvent): void => {
        if (!Util.isAppView() || typeof openExternalLink !== "function")
            return;

        const anchor = (event.target as Element | null)?.closest<HTMLAnchorElement>('a[ltag="SmsDisclaimerTerms"], a[ltag="PrivacyPolicy"]');
        if (!anchor)
            return;

        event.preventDefault();
        openExternalLink(anchor.href);
    }
}
